/** Istilah operasional dapur — konsisten di seluruh PWA. */
export const kitchenTerms = {
  appName: 'Superoti Dapur',
  modules: {
    home: 'Beranda',
    production: 'Produksi',
    dispatch: 'Distribusi',
    stock: 'Stok',
    waste: 'Pemusnahan',
    attendance: 'Absensi',
  },
  production: {
    plan: 'Plan HO',
    session: 'Sesi produksi',
    postStock: 'Masuk stok',
    saveDraft: 'Simpan hasil produksi',
  },
  dispatch: {
    handover: 'Serah ke delman',
    saveDraft: 'Simpan pengiriman',
    inTransit: 'Sudah ke delman',
    received: 'Toko sudah terima',
  },
  waste: {
    proposal: 'Proposal pemusnahan',
    goodStock: 'Good stock',
    wasteStock: 'Waste stock',
    materialStock: 'Bahan baku',
    submitHo: 'Kirim ke HO',
    execute: 'Eksekusi pemusnahan',
  },
  attendance: {
    checkIn: 'Masuk',
    checkOut: 'Keluar',
    checkInVerb: 'masuk',
    checkOutVerb: 'keluar',
    notYet: 'Belum masuk',
    onShift: 'Sedang shift',
    finished: 'Selesai',
  },
  sync: {
    online: 'Online',
    offline: 'Offline',
    pending: (count: number) => `${count} menunggu sinkron`,
    queued: 'Tersimpan di tablet — akan disinkronkan saat online',
  },
} as const
